var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.206 2.566h10.483a3.478 3.478 0 0 1 3.478 3.478v9.366a.993.993 0 1 1-1.987 0V6.044a1.49 1.49 0 0 0-1.49-1.49H6.205a.969.969 0 0 1-.994-.994.994.994 0 0 1 .994-.994zm7.998 17.241h-9.39a2.981 2.981 0 0 1-2.981-2.98V8.528a2.981 2.981 0 0 1 2.981-2.981h9.39a2.981 2.981 0 0 1 2.981 2.98v8.298a2.981 2.981 0 0 1-2.98 2.981zM4.111 7.827a.994.994 0 0 0-.29.702v8.297a.994.994 0 0 0 .993.994h9.39a.97.97 0 0 0 .994-.994V8.53a.97.97 0 0 0-.994-.994h-9.39a.994.994 0 0 0-.703.291z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d24fbfa88a568569f833b8e7fbd98a3d.svg";
export { ForwardRef as ReactComponent };